module.exports = __webpack_public_path__ + "static/media/about-strength-carousel-2.75a6c012.jpg";